export * from './header/header.component';
export * from './footer/footer.component';
export * from './modal/modal.component';
export * from './isi/isi.component';
export * from './medicine/medicine.component';
export * from './video-player/video-player.component';
export * from './chat/chat.component';
export * from './mobile-warning/mobile-warning.component';
